export default "__VITE_ASSET__D7$d67ww__"